import { LocalDate } from '../../../utilities/local-date';

/**
 * Takes a start and end time for a period
 * Returns a display text representing the period
 */
export function periodTimeDisplayText(
  startDate: LocalDate,
  startTime: string,
  endDate: LocalDate,
  endTime: string,
  yearIfOther: boolean,
): string {
  let startYear = '';
  let endYear = '';
  if (yearIfOther) {
    const thisYear = LocalDate.now().toString().slice(0, 4);
    const periodStartYear = startDate.toString().slice(0, 4);
    const periodEndYear = endDate.toString().slice(0, 4);
    if (thisYear !== periodStartYear || thisYear !== periodEndYear) {
      startYear = ' ' + periodStartYear;
      if (periodStartYear !== periodEndYear) {
        endYear = ' ' + periodEndYear;
      }
    }
  }
  let startTimeText = '';
  if (startTime && (startTime !== '00:00' || (startDate.isSame(endDate) && endTime !== '00:00'))) {
    startTimeText = startTime.replace(':', '.');
  }
  let endTimeText = '';
  if (endTime) {
    endTimeText = endTime.replace(':', '.');
  }
  if (startDate.isSame(endDate)) {
    let divider = ' - ';
    if (!startTimeText && !endTimeText) {
      divider = '';
    }
    return startDate.toStringForDisplayWithDayOfWeek() + startYear + ' ' + startTimeText + divider + endTimeText;
  }
  return (
    startDate.toStringForDisplayWithDayOfWeek() +
    startYear +
    ' ' +
    startTimeText +
    ' - ' +
    endDate.toStringForDisplayWithDayOfWeek() +
    endYear +
    ' ' +
    endTimeText
  );
}
